<template>
  <el-dialog
    title="订单商品详情"
    :visible.sync="isShow"
    :before-close="handleClose"
    width="50%"
    :close-on-click-modal="false"
    style="font-size:14px; "
  >
  <div class="detailList">
    <el-table
      :data="detailList"
      style="width: 100%">
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="240px"
        >
        <template slot-scope="scope">
        {{scope.row.goodsName}}
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsId"
        label="商品编号"
        width="180px">
        <template slot-scope="scope">
        {{scope.row.goodsId}}
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsCount"
        label="商品数量"
        width="100px">
        <template slot-scope="scope">
        {{scope.row.goodsCount}}
        </template>
      </el-table-column>
      <el-table-column
        prop="commissionTotalCost"
        label="计佣价格"
        width="100px">
        <template slot-scope="scope">
        {{scope.row.commissionTotalCost}}
        </template>
      </el-table-column>
      <el-table-column
        label="佣金比例"
        width="100px">
        <template slot-scope="scope">
        {{scope.row.commissionRate}}%
        </template>
      </el-table-column>
      <el-table-column
        label="预估佣金"
        width="100px">
        <template slot-scope="scope">
        {{scope.row.commission}}
        </template>
      </el-table-column>
    </el-table>

  </div>
  </el-dialog>
</template>

<script>
import {emptyTrans, formatMoney} from '@/api/dataTrans.js'
export default {
  props: ["data",  'showTotal', 'detaillist'],
  data() {
    return {
      isShow: true,
      detailList:this.detaillist,
      listLoading: false

    }
  },

  mounted() {
    console.log(JSON.stringify(this.detailList))
  },
  methods: {
    //关闭弹窗
    handleClose() {
      this.$emit("close", null)
    },
    // queryData() {
    //   this.pageInfo.currentPage = 1
    //   this.getDetail()
    // },
    // getDetail(val) {
    //   var parmasList = {}
    //   if (this.time && this.time.length > 0) {
    //     parmasList.startTime = this.time[0]
    //     parmasList.endTime = this.time[1]
    //   } else {
    //     parmasList.startTime = null;
    //     parmasList.endTime = null;
    //   }
      
    // },
    moneyTrans(_val) {
      return formatMoney(_val)
    },
    emptyDeal(_val) {
      if (_val == '0') {
        return _val
      }
      return emptyTrans(_val)
    }
  }
}
</script>
<style scoped lang="scss">
// /deep/ .el-dialog .el-dialog__body {
//   font-size: 14px;
// }

// /deep/ .el-dialog__header .el-dialog__title {
//   font-size: 16px;
// }

// /deep/ .el-date-editor .el-range__icon {
//   line-height: 18px;
// }
</style>
